import script from "./AdminRssPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRssPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminRssPage.vue?vue&type=style&index=0&id=3f2b1ba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2b1ba3"]])

export default __exports__